import { React, useState, useEffect, useRef } from "react";
import clsx from "clsx";
import {Col, Container, Form} from "react-bootstrap";
import { useHistory } from "react-router";
import _ from "lodash";
import ManualTransferTable from "../components/ManualTransferTable";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as authSelectors from "../../../selectors/auth";
import * as StorageManager from "../../../utils/StorageManager";
import constants from "../../../constants";
import NotificationMessage from "../../../utils/NotificationMessage";
import * as axiosInstance from "../../../services/axiosInstance";
import PAGE from "../../../utils/Destination";
import LoadingOverlay from "../../../components/LoadingOverlay";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import * as paymentSelectors from "../../../selectors/payment";
import * as paymentActions from "../../../action/payment";
import { getPaymentCurrency } from "../../../selectors/payment";
import ManualTransferRemark from "../ManualTransferRemark";
function ManualTransfer({ label, items, paymentConfig }) {
  const [token, setToken] = useState(null);
  const isLogout = useSelector((state) => authSelectors.getAuthIsLogout(state));
  const [loading, setLoading] = useState(false);
  const [payment, setPayment] = useState(1);
  const [currentDeposit, setCurrentDeposit] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const manualPaymentTransferRef = useRef(null);
  const total = useSelector((state) => paymentSelectors.getPaymentTotal(state));
  const paymentTotal = useSelector((state) => paymentSelectors.getPaymentTotalAmount(state));
  const paymentItems = useSelector((state) => paymentSelectors.getPaymentItems(state));
  const paymentCurrency = useSelector((state) => paymentSelectors.getPaymentCurrency(state));
  const date = new Date();
  const dateNow = date.toISOString().split("T")[0];
  const timeNow = date.toTimeString().split(" ")[0].slice(0, 5);
  const dispatch = useDispatch();
  let history = useHistory();

  useEffect(() => {
    setTokenFunction();
  }, [isLogout]);

  async function setTokenFunction() {
    setToken(await StorageManager.retrieveToken(constants.AUTH_TOKEN));
  }
  const handleUploadClick = (e) => {
    e.preventDefault();
    const fileInput = document.getElementById("fileInput");
    if (fileInput) {
      fileInput.click();
    } else {
      NotificationMessage.error("File input element not found.");
    }
  };

  const onSubmit = async (values) => {
    const currentAmount = values.current_amount;

    if(currentAmount.toString() !== paymentTotal.toString()){
      NotificationMessage.error('Current amount and payment amount is not tally. Please check your items amount.')
      return
    }
    let formData = new FormData(manualPaymentTransferRef.current);
    setLoading(true);
    try {
      const response = await axiosInstance.post(
        "clientarea/payment/manual-payment",
        formData,
        false,
        false,
        "",
        {
          "Content-Type": "multipart/form-data",
        },
      );
      if (response && response.status) {
        dispatch(paymentActions.setPaymentAmount(null));
        history.push(PAGE.PAYMENT_HISTORY);
      }
    } catch (error) {
      const errorResponse = _.get(error, ["data", "errors"], null);
      if (errorResponse) {
        _.forEach(errorResponse, (items, itemMessage) => {
          // if(!_.includes(itemMessage,'contracts') && !_.isEqual(itemMessage,'items')) {
            setError(itemMessage, {type: "manual", message: items});
          // }
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const onError = (errors,e) => {
    if(_.get(errors,['current_amount'])){
      NotificationMessage.error('Current amount and payment amount is not tally. Please check your items amount.')
    }
    if(_.get(errors,['items','message',0])){
      NotificationMessage.error(_.get(errors,['items','message',0]))
    }
  };

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    getValues,
    setError,
    getFieldState,
    watch,
    reset,
      clearErrors
  } = useForm({
    mode: "onTouched",
    reValidateMode: "onSubmit",
    defaultValues: {
      payment_amount: total,
      deposit_amount: _.isNaN(Number(paymentTotal) - Number(total))
        ? 0
        : Number(paymentTotal) - Number(total),
      contracts: _.map(paymentItems, (item) => {
        const subTotal = _.get(item, ["subTotal"], 0);
        const contractReference = _.get(item, ["data", "contract_reference"], "");
        return {
          contract_reference: contractReference,
          payment_amount: subTotal,
        };
      }),
      bank_transaction_date: dateNow,
      bank_transaction_time: timeNow
    },
  });

  const onClickAddNew = (e) => {
    e.preventDefault();
    setPayment((prev) => prev + 1);
  };

  const removeDeposit = (e) => {
    e.preventDefault();
    let newItems = getValues("items");
    newItems = _.filter(newItems, (item, index) => index !== currentDeposit);
    setValue("items", newItems);
    setDeleteModal(false);
    setCurrentDeposit(null);
    setPayment((prev) => prev - 1);
  };

  const openDeleteModal = (e, index) => {
    e.preventDefault();
    setCurrentDeposit(index);
    setDeleteModal(true);
  };

  return (
      <Container fluid>
        <div className={"primary-border-table-border"} style={{backgroundColor: "white"}}>
          <div
              className={clsx("custom-card-label-container text-center d-flex justify-content-center align-items-center flex-wrap flex-lg-nowrap")}>
            <h2 className={clsx("d-block w-100 my-2")}>Manual Transfer</h2>
            <button className={clsx("btn custom-button-fill-light float-none float-lg-end text-nowrap")} style={{ right: '50px' }} onClick={onClickAddNew}>
              Add New Deposit
            </button>
          </div>
          <br/>
          <div className="padding-12px d-flex">
            <p className="payment-detail-title text-bold-600">Deposit Details</p>
          </div>
          <div className={clsx("custom-table-info-container padding-12px")}>
            <Form ref={manualPaymentTransferRef} onSubmit={handleSubmit(onSubmit, onError)}>
              <div className={"responsive-table-border"}>
                <ManualTransferTable
                    config={paymentConfig}
                    setValue={setValue}
                    payment={payment}
                    paymentTotal={paymentTotal}
                    total={total}
                    setPayment={setPayment}
                    handleUploadClick={handleUploadClick}
                    onClickAddNew={onClickAddNew}
                    register={register}
                    formValues={getValues}
                    contracts={paymentItems}
                    removeDeposit={openDeleteModal}
                    watch={watch}
                    errors={errors}
                    currency={paymentCurrency}
                    dateNow={dateNow}
                    timeNow={timeNow}
                    clearErrors={clearErrors}
                />
              </div>
              <div className="d-flex justify-content-center py-3">
                <button
                    className={clsx("btn custom-button-back")}
                    onClick={(e) => {
                      e.preventDefault();
                      reset();
                    }}
                >
                  Reset
                </button>
                <button
                    className={clsx("btn custom-button-primary")}
                    type="submit"
                    style={{backgroundColor: "#9D7905"}}
                >
                  Submit
                </button>
              </div>
              <LoadingOverlay loading={loading}></LoadingOverlay>
            </Form>
          </div>
        </div>
        <ManualTransferRemark></ManualTransferRemark>
        <Modal show={deleteModal} onHide={() => setDeleteModal(false)} centered={true}>
          <Modal.Body>Are you confirm to delete this deposit detail?</Modal.Body>
          <Modal.Footer style={{justifyContent: "flex-end"}}>
            <Button variant="secondary" onClick={() => setDeleteModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={(e) => removeDeposit(e)}>
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
  );
}

export default ManualTransfer;
